
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MapPin } from "lucide-react";

interface StateSelectorProps {
  selectedState: string;
  onStateChange: (value: string) => void;
  disabled?: boolean;
}

const StateSelector: React.FC<StateSelectorProps> = ({ selectedState, onStateChange, disabled = false }) => {
  return (
    <Card className={disabled ? "opacity-50" : ""}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="w-5 h-5" />
          Estado
        </CardTitle>
        <CardDescription>
          Escolha o estado da loteria
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Select value={selectedState} onValueChange={onStateChange} disabled={disabled}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="z-50 bg-background border border-border shadow-lg">
            <SelectItem value="TODO_BRASIL" className="text-foreground hover:bg-muted focus:bg-muted">Todo Brasil</SelectItem>
            <SelectItem value="AC" className="text-foreground hover:bg-muted focus:bg-muted">Acre</SelectItem>
            <SelectItem value="AL" className="text-foreground hover:bg-muted focus:bg-muted">Alagoas</SelectItem>
            <SelectItem value="AP" className="text-foreground hover:bg-muted focus:bg-muted">Amapá</SelectItem>
            <SelectItem value="AM" className="text-foreground hover:bg-muted focus:bg-muted">Amazonas</SelectItem>
            <SelectItem value="BA" className="text-foreground hover:bg-muted focus:bg-muted">Bahia</SelectItem>
            <SelectItem value="CE" className="text-foreground hover:bg-muted focus:bg-muted">Ceará</SelectItem>
            <SelectItem value="DF" className="text-foreground hover:bg-muted focus:bg-muted">Distrito Federal</SelectItem>
            <SelectItem value="ES" className="text-foreground hover:bg-muted focus:bg-muted">Espírito Santo</SelectItem>
            <SelectItem value="GO" className="text-foreground hover:bg-muted focus:bg-muted">Goiás</SelectItem>
            <SelectItem value="MA" className="text-foreground hover:bg-muted focus:bg-muted">Maranhão</SelectItem>
            <SelectItem value="MT" className="text-foreground hover:bg-muted focus:bg-muted">Mato Grosso</SelectItem>
            <SelectItem value="MS" className="text-foreground hover:bg-muted focus:bg-muted">Mato Grosso do Sul</SelectItem>
            <SelectItem value="MG" className="text-foreground hover:bg-muted focus:bg-muted">Minas Gerais</SelectItem>
            <SelectItem value="PA" className="text-foreground hover:bg-muted focus:bg-muted">Pará</SelectItem>
            <SelectItem value="PB" className="text-foreground hover:bg-muted focus:bg-muted">Paraíba</SelectItem>
            <SelectItem value="PR" className="text-foreground hover:bg-muted focus:bg-muted">Paraná</SelectItem>
            <SelectItem value="PE" className="text-foreground hover:bg-muted focus:bg-muted">Pernambuco</SelectItem>
            <SelectItem value="PI" className="text-foreground hover:bg-muted focus:bg-muted">Piauí</SelectItem>
            <SelectItem value="RJ" className="text-foreground hover:bg-muted focus:bg-muted">Rio de Janeiro</SelectItem>
            <SelectItem value="RN" className="text-foreground hover:bg-muted focus:bg-muted">Rio Grande do Norte</SelectItem>
            <SelectItem value="RS" className="text-foreground hover:bg-muted focus:bg-muted">Rio Grande do Sul</SelectItem>
            <SelectItem value="RO" className="text-foreground hover:bg-muted focus:bg-muted">Rondônia</SelectItem>
            <SelectItem value="RR" className="text-foreground hover:bg-muted focus:bg-muted">Roraima</SelectItem>
            <SelectItem value="SC" className="text-foreground hover:bg-muted focus:bg-muted">Santa Catarina</SelectItem>
            <SelectItem value="SP" className="text-foreground hover:bg-muted focus:bg-muted">São Paulo</SelectItem>
            <SelectItem value="SE" className="text-foreground hover:bg-muted focus:bg-muted">Sergipe</SelectItem>
            <SelectItem value="TO" className="text-foreground hover:bg-muted focus:bg-muted">Tocantins</SelectItem>
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
};

export default StateSelector;
